module.exports = __webpack_public_path__ + "ie.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ie.svg
// module id = 606
// module chunks = 0